import type { LeaderboardEntry, TeamMember } from "../types/core";

// Inactive reps never render (Jul-3 2026 roster doctrine). TeamContext hands out raw
// daily_leaderboard rows, so rep-facing lists fed from it must drop anyone whose
// organization_members.status is 'inactive'. Deny-list on purpose: a rep missing from the
// capped members fetch stays visible instead of the whole list emptying.
export function inactiveRepIds(teamMembers: TeamMember[]): Set<string> {
  return new Set(teamMembers.filter((m) => m.status === "inactive").map((m) => m.user_id));
}

export function dropInactiveReps(
  leaderboard: LeaderboardEntry[],
  teamMembers: TeamMember[]
): LeaderboardEntry[] {
  const inactive = inactiveRepIds(teamMembers);
  return inactive.size === 0 ? leaderboard : leaderboard.filter((e) => !inactive.has(e.rep_id));
}
